import React from 'react';
import Box from '@material-ui/core/Box';
import UserContext from '../../common/UserContext';
import Paper from '@material-ui/core/Paper';
import HdaeLockup from './HdaeLockup.png';
import DigiKnowLogo from './DigiKnowLogo.png';
import {JsonAdDetail} from '../../../ext/lib/types';
import {displayAdCost} from '../../../ext/billing';
import useApi from '../../../hooks/useApi';
import {useTheme, makeStyles} from '@material-ui/core/styles';
import {useParams} from 'react-router';
import {userEmail} from '../../common/UserContext';
import {matchError} from '../../../ext/common/sanctuary';
import {invoiceNumber} from '../../../ext/billing';
import {displayJsonDateTime} from '../../../ext/lib/temporal';
import {displayType, isPrepay, isRecharge} from './ad-invoice-helper';
import o from 'ramda/src/o';

type Args = {key: string};

const userKey = o(btoa, userEmail);

const AdInvoice: React.FC = (): JSX.Element => {
  const {apiToken, user} = React.useContext(UserContext);
  const {key} = useParams() as Args;
  const ad = useApi<JsonAdDetail>(apiToken || 'undefined-token', `/api/v1/requests/${userKey(user)}/${key}`);
  const theme = useTheme();
  const useStyles = makeStyles({
    invoiceHeading: {
      maxWidth: '2rem',
      color: theme.palette.primary.main,
      fontSize: theme.typography.h2.fontSize
    }
  });
  const styles = useStyles();

  // TODO: Create display component for AdInvoice and write ad invoice tests
  function invoice(ad: JsonAdDetail): JSX.Element {
    const InvoiceContent = <>
      <div><img style={{width: '21em'}} src={HdaeLockup} /></div>
      <div style={{textAlign: 'right'}}>
        <img style={{width: '18em'}} src={DigiKnowLogo} />
        <address style={{fontStyle: 'normal', textAlign: 'right'}}>
          1501 Residential Services<br />
          Santa Barbara, CA 93106-6130<br />
          <a href="https://www.hdae.ucsb.edu/advertise/digital-signage-network/digiknow-home">www.hdae.ucsb.edu/advertise/digital-signage-network/digiknow-home</a>
        </address>
      </div>

      <p>
        <span className={styles.invoiceHeading}>Date:</span>&nbsp;{displayJsonDateTime(ad.orderedAt)}<br />
        <span className={styles.invoiceHeading}>Invoice Number:</span>&nbsp;{invoiceNumber(ad)}<br />
        <span className={styles.invoiceHeading}>Name:</span>&nbsp;{ad.adName}<br />
        <span className={styles.invoiceHeading}>Contact:</span>&nbsp;{ad.userFirstName} {ad.userLastName}<br />
        <span className={styles.invoiceHeading}>Type:</span>&nbsp;{displayType(ad)}<br />
        <span className={styles.invoiceHeading}>Department:</span>&nbsp;{ad.organization}<br />
        {
          isRecharge(ad.organizationType)
          ? <><span className={styles.invoiceHeading}>Recharge number:</span>&nbsp;{ad.rechargeNumber}<br /></>
          : undefined
        }
        <span className={styles.invoiceHeading}>Total:</span>&nbsp;{displayAdCost(ad)}
      </p>

      {
        isPrepay(ad.organizationType)
        ? <p>
            Please note: all ads must be paid for in advance.
            A check made payable to UC Regents can be dropped off at
            1501 Residential Services between Santa Cruz Hall and DLG, across from parking lot 5.
          </p>
        : undefined
      }

      <p>
        {
          isRecharge(ad.organizationType)
          ? <span>Your department account number will be recharged at the end of the quarter. </span>
          : undefined
        }
        Please contact KC Buller, Marketing &amp; Communications Specialist for Housing, Dining &amp; Auxiliary Enterprises.
        If you have any questions about your ad and broadcasting it on DigiKnow:&nbsp;<a href="mailto:kcbuller@ucsb.edu">kcbuller@ucsb.edu</a>, 805.893.4864.
      </p>
      <p>Thank you for broadcasting with DigiKnow!</p>
    </>;

    return <>
      <Box displayPrint="none" component={Paper} style={{padding: '2rem'}} >
        {InvoiceContent}
      </Box>
      <Box display="none" displayPrint="block">{InvoiceContent}</Box>
    </>;
  }

  return ad
    ? matchError(
      err => {
        console.error(err.message);
        return <div className="alert error">An error occurred. Try again or contact support</div>;
      },
      ad =>
        invoice(ad as JsonAdDetail),
      ad)
    : <div className="loading-spinner"></div>;
};
export default AdInvoice;
